import React, { useState, useEffect, Fragment } from "react";
import API from "../../services/API";
import { toast } from "react-toastify";

const AgencyHolidayConfig = () => {
  const [holidays, setHolidays] = useState([]);
  const [holidayForm, setHolidayForm] = useState({
    holiday_name: "",
    start_date: "",
    end_date: "",
    is_recurring: false,
    description: "",
  });
  const [holidayLoading, setHolidayLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedHoliday, setSelectedHoliday] = useState(null);

  const [extraDays, setExtraDays] = useState([]);
  const [extraForm, setExtraForm] = useState({
    extra_name: "",
    start_date: "",
    end_date: "",
    is_recurring: false,
    description: "",
  });
  const [extraLoading, setExtraLoading] = useState(false);
  const [showExtraDeleteModal, setShowExtraDeleteModal] = useState(false);
  const [selectedExtra, setSelectedExtra] = useState(null);

  const getHeaders = () => ({
    "Content-Type": "application/json",
    Accept: "application/json",
    token: localStorage.getItem("token"),
  });

  const fetchHolidays = async () => {
    setHolidayLoading(true);

    try {
      const response = await API.get("/school/holidays?is_portal=true", {
        headers: getHeaders(),
      });

      if (response.data.response_code === 1000) {
        setHolidays(response.data.data || []);
      } else {
        toast.error(response.data.message || "Gagal mendapatkan senarai cuti");
      }
    } catch (err) {
      console.error("Fetch holidays error:", err);
      toast.error("Ralat semasa mendapatkan senarai cuti");
    } finally {
      setHolidayLoading(false);
    }
  };

  const fetchExtraDays = async () => {
    setExtraLoading(true);

    try {
      const response = await API.get("/school/extraDays?is_portal=true", {
        headers: getHeaders(),
      });

      if (response.data.response_code === 1000) {
        setExtraDays(response.data.data || []);
      } else {
        toast.error(
          response.data.message || "Gagal mendapatkan senarai hari bekerja tambahan"
        );
      }
    } catch (err) {
      console.error("Fetch extra days error:", err);
      toast.error("Ralat semasa mendapatkan senarai hari bekerja tambahan");
    } finally {
      setExtraLoading(false);
    }
  };

  useEffect(() => {
    fetchHolidays();
    fetchExtraDays();
  }, []);

  const handleHolidayChange = (e) => {
    const { name, value, type, checked } = e.target;

    setHolidayForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleExtraChange = (e) => {
    const { name, value, type, checked } = e.target;

    setExtraForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAddHoliday = async () => {
    if (
      !holidayForm.holiday_name ||
      !holidayForm.start_date ||
      !holidayForm.end_date
    ) {
      toast.error("Sila lengkapkan nama cuti, tarikh mula dan tarikh tamat");
      return;
    }

    try {
      const response = await API.post(
        "/school/holidays?is_portal=true",
        holidayForm,
        { headers: getHeaders() }
      );

      if (response.data.response_code === 1000) {
        toast.success("Cuti berjaya disimpan");

        setHolidayForm({
          holiday_name: "",
          start_date: "",
          end_date: "",
          is_recurring: false,
          description: "",
        });

        fetchHolidays();
      } else {
        toast.error(response.data.message || "Gagal menambah cuti");
      }
    } catch (err) {
      console.error("Add holiday error:", err);
      toast.error("Ralat semasa menambah cuti");
    }
  };

  const handleAddExtraDay = async () => {
    if (!extraForm.extra_name || !extraForm.start_date || !extraForm.end_date) {
      toast.error(
        "Sila lengkapkan nama hari bekerja tambahan, tarikh mula dan tarikh tamat"
      );
      return;
    }

    try {
      const response = await API.post(
        "/school/extraDays?is_portal=true",
        extraForm,
        { headers: getHeaders() }
      );

      if (response.data.response_code === 1000) {
        toast.success("Hari bekerja tambahan berjaya disimpan");

        setExtraForm({
          extra_name: "",
          start_date: "",
          end_date: "",
          is_recurring: false,
          description: "",
        });

        fetchExtraDays();
      } else {
        toast.error(
          response.data.message || "Gagal menambah hari bekerja tambahan"
        );
      }
    } catch (err) {
      console.error("Add extra day error:", err);
      toast.error("Ralat semasa menambah hari bekerja tambahan");
    }
  };

  const openDeleteModal = (holiday) => {
    setSelectedHoliday(holiday);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setSelectedHoliday(null);
    setShowDeleteModal(false);
  };

  const confirmDeleteHoliday = async () => {
    if (!selectedHoliday) return;

    try {
      const response = await API.delete(
        `/school/holidays/${selectedHoliday.id}?is_portal=true`,
        { headers: getHeaders() }
      );

      if (response.data.response_code === 1000) {
        toast.success("Cuti berjaya dipadam");
        fetchHolidays();
      } else {
        toast.error(response.data.message || "Gagal memadam cuti");
      }
    } catch (err) {
      console.error("Delete holiday error:", err);
      toast.error("Ralat semasa memadam cuti");
    } finally {
      closeDeleteModal();
    }
  };

  const openExtraDeleteModal = (extraDay) => {
    setSelectedExtra(extraDay);
    setShowExtraDeleteModal(true);
  };

  const closeExtraDeleteModal = () => {
    setSelectedExtra(null);
    setShowExtraDeleteModal(false);
  };

  const confirmDeleteExtra = async () => {
    if (!selectedExtra) return;

    try {
      const response = await API.delete(
        `/school/extraDays/${selectedExtra.id}?is_portal=true`,
        { headers: getHeaders() }
      );

      if (response.data.response_code === 1000) {
        toast.success("Hari bekerja tambahan berjaya dipadam");
        fetchExtraDays();
      } else {
        toast.error(response.data.message || "Gagal memadam hari bekerja tambahan");
      }
    } catch (err) {
      console.error("Delete extra day error:", err);
      toast.error("Ralat semasa memadam hari bekerja tambahan");
    } finally {
      closeExtraDeleteModal();
    }
  };

  return (
    <Fragment>
      <div
        className="container-fluid"
        style={{
          background: "linear-gradient(180deg, #f8fbff 0%, #eef6ff 100%)",
          minHeight: "100vh",
          paddingTop: "24px",
          paddingBottom: "40px",
        }}
      >
        <div className="card mb-4" style={cardStyle}>
          <div style={cardHeaderStyle}>
            <div>
              <div style={kickerStyle}>Tetapan Kalendar Agensi</div>
              <h4 style={titleStyle}>Cuti / Hari Tidak Beroperasi</h4>
              <p style={subtitleStyle}>
                Tetapkan cuti atau hari tidak beroperasi supaya sistem kehadiran
                tidak mengira hari tersebut sebagai hari bekerja biasa.
              </p>
            </div>
          </div>

          <div className="card-body" style={bodyStyle}>
            <div className="row g-3">
              <div className="col-md-3">
                <label style={labelStyle}>Nama Cuti</label>
                <input
                  type="text"
                  className="form-control"
                  name="holiday_name"
                  value={holidayForm.holiday_name}
                  onChange={handleHolidayChange}
                  placeholder="Contoh: Deepavali"
                  style={inputStyle}
                />
              </div>

              <div className="col-md-3">
                <label style={labelStyle}>Tarikh Mula</label>
                <input
                  type="date"
                  className="form-control"
                  name="start_date"
                  value={holidayForm.start_date}
                  onChange={handleHolidayChange}
                  style={inputStyle}
                />
              </div>

              <div className="col-md-3">
                <label style={labelStyle}>Tarikh Tamat</label>
                <input
                  type="date"
                  className="form-control"
                  name="end_date"
                  value={holidayForm.end_date}
                  onChange={handleHolidayChange}
                  style={inputStyle}
                />
              </div>

              <div className="col-md-3">
                <label style={labelStyle}>Berulang Setiap Tahun</label>
                <select
                  className="form-control"
                  name="is_recurring"
                  value={holidayForm.is_recurring ? "1" : "0"}
                  onChange={(e) =>
                    setHolidayForm((prev) => ({
                      ...prev,
                      is_recurring: e.target.value === "1",
                    }))
                  }
                  style={inputStyle}
                >
                  <option value="0">Tidak</option>
                  <option value="1">Ya</option>
                </select>
              </div>

              <div className="col-md-12">
                <label style={labelStyle}>Catatan</label>
                <textarea
                  name="description"
                  className="form-control"
                  rows={2}
                  placeholder="Catatan tambahan jika ada"
                  value={holidayForm.description}
                  onChange={handleHolidayChange}
                  style={inputStyle}
                />
              </div>

              <div className="col-md-12 text-end">
                <button style={primaryButtonStyle} onClick={handleAddHoliday}>
                  Tambah Cuti
                </button>
              </div>
            </div>
          </div>

          <div className="card-body" style={bodyStyle}>
            <h5 style={sectionTitleStyle}>Senarai Cuti / Hari Tidak Beroperasi</h5>

            {holidayLoading ? (
              <p style={mutedTextStyle}>Sedang memuatkan data...</p>
            ) : holidays.length === 0 ? (
              <EmptyState text="Tiada cuti direkodkan buat masa ini." />
            ) : (
              <div className="table-responsive">
                <table className="table align-middle" style={tableStyle}>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Cuti</th>
                      <th>Tarikh Mula</th>
                      <th>Tarikh Tamat</th>
                      <th>Berulang</th>
                      <th>Catatan</th>
                      <th>Tindakan</th>
                    </tr>
                  </thead>

                  <tbody>
                    {holidays.map((holiday, index) => (
                      <tr key={holiday.id}>
                        <td>{index + 1}</td>
                        <td>
                          <strong>{holiday.holiday_name}</strong>
                        </td>
                        <td>{holiday.start_date}</td>
                        <td>{holiday.end_date}</td>
                        <td>
                          <span
                            style={
                              holiday.is_recurring
                                ? successBadgeStyle
                                : neutralBadgeStyle
                            }
                          >
                            {holiday.is_recurring ? "Ya" : "Tidak"}
                          </span>
                        </td>
                        <td>{holiday.description || "-"}</td>
                        <td>
                          <button
                            style={dangerButtonStyle}
                            onClick={() => openDeleteModal(holiday)}
                          >
                            Padam
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        <div className="card" style={cardStyle}>
          <div style={cardHeaderStyle}>
            <div>
              <div style={kickerStyle}>Tetapan Hari Bekerja Tambahan</div>
              <h4 style={titleStyle}>Hari Bekerja Tambahan</h4>
              <p style={subtitleStyle}>
                Tambah hari bekerja tambahan seperti hari operasi khas, program
                rasmi atau hari yang perlu dikira sebagai hari bekerja.
              </p>
            </div>
          </div>

          <div className="card-body" style={bodyStyle}>
            <div className="row g-3">
              <div className="col-md-3">
                <label style={labelStyle}>Nama Hari Bekerja Tambahan</label>
                <input
                  type="text"
                  className="form-control"
                  name="extra_name"
                  value={extraForm.extra_name}
                  onChange={handleExtraChange}
                  placeholder="Contoh: Operasi Khas"
                  style={inputStyle}
                />
              </div>

              <div className="col-md-3">
                <label style={labelStyle}>Tarikh Mula</label>
                <input
                  type="date"
                  className="form-control"
                  name="start_date"
                  value={extraForm.start_date}
                  onChange={handleExtraChange}
                  style={inputStyle}
                />
              </div>

              <div className="col-md-3">
                <label style={labelStyle}>Tarikh Tamat</label>
                <input
                  type="date"
                  className="form-control"
                  name="end_date"
                  value={extraForm.end_date}
                  onChange={handleExtraChange}
                  style={inputStyle}
                />
              </div>

              <div className="col-md-3">
                <label style={labelStyle}>Berulang Setiap Tahun</label>
                <select
                  className="form-control"
                  name="is_recurring"
                  value={extraForm.is_recurring ? "1" : "0"}
                  onChange={(e) =>
                    setExtraForm((prev) => ({
                      ...prev,
                      is_recurring: e.target.value === "1",
                    }))
                  }
                  style={inputStyle}
                >
                  <option value="0">Tidak</option>
                  <option value="1">Ya</option>
                </select>
              </div>

              <div className="col-md-12">
                <label style={labelStyle}>Catatan</label>
                <textarea
                  name="description"
                  className="form-control"
                  rows={2}
                  placeholder="Catatan tambahan jika ada"
                  value={extraForm.description}
                  onChange={handleExtraChange}
                  style={inputStyle}
                />
              </div>

              <div className="col-md-12 text-end">
                <button style={primaryButtonStyle} onClick={handleAddExtraDay}>
                  Tambah Hari Bekerja
                </button>
              </div>
            </div>
          </div>

          <div className="card-body" style={bodyStyle}>
            <h5 style={sectionTitleStyle}>Senarai Hari Bekerja Tambahan</h5>

            {extraLoading ? (
              <p style={mutedTextStyle}>Sedang memuatkan data...</p>
            ) : extraDays.length === 0 ? (
              <EmptyState text="Tiada hari bekerja tambahan direkodkan buat masa ini." />
            ) : (
              <div className="table-responsive">
                <table className="table align-middle" style={tableStyle}>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Hari Bekerja Tambahan</th>
                      <th>Tarikh Mula</th>
                      <th>Tarikh Tamat</th>
                      <th>Berulang</th>
                      <th>Catatan</th>
                      <th>Tindakan</th>
                    </tr>
                  </thead>

                  <tbody>
                    {extraDays.map((extraDay, index) => (
                      <tr key={extraDay.id}>
                        <td>{index + 1}</td>
                        <td>
                          <strong>{extraDay.extra_name}</strong>
                        </td>
                        <td>{extraDay.start_date}</td>
                        <td>{extraDay.end_date}</td>
                        <td>
                          <span
                            style={
                              extraDay.is_recurring
                                ? successBadgeStyle
                                : neutralBadgeStyle
                            }
                          >
                            {extraDay.is_recurring ? "Ya" : "Tidak"}
                          </span>
                        </td>
                        <td>{extraDay.description || "-"}</td>
                        <td>
                          <button
                            style={dangerButtonStyle}
                            onClick={() => openExtraDeleteModal(extraDay)}
                          >
                            Padam
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      {showDeleteModal && (
        <ConfirmModal
          title="Sahkan Padam Cuti"
          message={
            <>
              Adakah anda pasti mahu memadam cuti{" "}
              <strong>{selectedHoliday?.holiday_name}</strong>?
            </>
          }
          onCancel={closeDeleteModal}
          onConfirm={confirmDeleteHoliday}
        />
      )}

      {showExtraDeleteModal && (
        <ConfirmModal
          title="Sahkan Padam Hari Bekerja Tambahan"
          message={
            <>
              Adakah anda pasti mahu memadam hari bekerja tambahan{" "}
              <strong>{selectedExtra?.extra_name}</strong>?
            </>
          }
          onCancel={closeExtraDeleteModal}
          onConfirm={confirmDeleteExtra}
        />
      )}
    </Fragment>
  );
};

export default AgencyHolidayConfig;

const EmptyState = ({ text }) => {
  return (
    <div
      style={{
        backgroundColor: "#f8fbff",
        border: "1px dashed #bfdbfe",
        borderRadius: "16px",
        padding: "24px",
        color: "#64748b",
        fontWeight: 600,
      }}
    >
      {text}
    </div>
  );
};

const ConfirmModal = ({ title, message, onCancel, onConfirm }) => {
  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        backgroundColor: "rgba(15, 23, 42, 0.55)",
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content"
          style={{
            borderRadius: "18px",
            border: "none",
            overflow: "hidden",
          }}
        >
          <div
            className="modal-header"
            style={{
              backgroundColor: "#fef2f2",
              borderBottom: "1px solid #fecaca",
            }}
          >
            <h5 style={{ color: "#dc2626", fontWeight: 800, margin: 0 }}>
              {title}
            </h5>

            <button type="button" className="btn-close" onClick={onCancel} />
          </div>

          <div className="modal-body">
            <div>{message}</div>
            <p className="text-danger small mt-2 mb-0">
              Tindakan ini tidak boleh dibatalkan selepas dipadam.
            </p>
          </div>

          <div
            className="modal-footer"
            style={{
              backgroundColor: "#f8fafc",
              borderTop: "1px solid #e2e8f0",
            }}
          >
            <button style={secondaryButtonStyle} onClick={onCancel}>
              Batal
            </button>

            <button style={deleteButtonStyle} onClick={onConfirm}>
              Ya, Padam
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const cardStyle = {
  border: "1px solid #dbeafe",
  borderRadius: "22px",
  boxShadow: "0 18px 45px rgba(11, 76, 156, 0.10)",
  overflow: "hidden",
};

const cardHeaderStyle = {
  background: "linear-gradient(135deg, #0B4C9C 0%, #0F65C9 55%, #1E88E5 100%)",
  borderBottom: "none",
  padding: "22px 26px",
};

const kickerStyle = {
  color: "#bfdbfe",
  fontSize: "12px",
  fontWeight: 800,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
  marginBottom: "6px",
};

const titleStyle = {
  color: "#ffffff",
  margin: 0,
  fontWeight: 800,
};

const subtitleStyle = {
  color: "#dbeafe",
  margin: "6px 0 0",
  fontSize: "14px",
};

const bodyStyle = {
  backgroundColor: "#ffffff",
  padding: "22px",
};

const labelStyle = {
  fontWeight: 700,
  color: "#0f172a",
  marginBottom: "6px",
};

const inputStyle = {
  borderRadius: "12px",
  borderColor: "#bfdbfe",
  padding: "10px 12px",
};

const sectionTitleStyle = {
  color: "#0B4C9C",
  fontWeight: 800,
  marginBottom: "14px",
};

const mutedTextStyle = {
  color: "#64748b",
  fontWeight: 600,
};

const tableStyle = {
  borderColor: "#dbeafe",
};

const primaryButtonStyle = {
  backgroundColor: "#0B4C9C",
  color: "#ffffff",
  fontWeight: 800,
  border: "none",
  borderRadius: "10px",
  padding: "10px 16px",
};

const secondaryButtonStyle = {
  backgroundColor: "#e2e8f0",
  color: "#334155",
  fontWeight: 800,
  border: "none",
  borderRadius: "10px",
  padding: "9px 16px",
};

const dangerButtonStyle = {
  backgroundColor: "#dc2626",
  color: "#ffffff",
  fontWeight: 800,
  border: "none",
  borderRadius: "10px",
  padding: "7px 13px",
  fontSize: "12px",
};

const deleteButtonStyle = {
  backgroundColor: "#dc2626",
  color: "#ffffff",
  fontWeight: 800,
  border: "none",
  borderRadius: "10px",
  padding: "9px 16px",
};

const successBadgeStyle = {
  display: "inline-flex",
  padding: "6px 11px",
  borderRadius: "999px",
  fontSize: "12px",
  fontWeight: 800,
  backgroundColor: "#dcfce7",
  color: "#166534",
  border: "1px solid #bbf7d0",
};

const neutralBadgeStyle = {
  display: "inline-flex",
  padding: "6px 11px",
  borderRadius: "999px",
  fontSize: "12px",
  fontWeight: 800,
  backgroundColor: "#f1f5f9",
  color: "#475569",
  border: "1px solid #cbd5e1",
};